import _ from 'lodash';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { Grid } from '@mui/material';

import { TCommonFieldProps, TCustomFieldProperty } from 'src/types';

import FormField from './FormField';
import Typography from './Typography';
import { FORM_ERROR_MAPPING } from 'src/constants';

interface SingleInstanceProps extends TCommonFieldProps {
  path: string;
  variant?: 'standard' | 'outlined';
  properties: TCustomFieldProperty[];
}

const SingleInstance: FC<SingleInstanceProps> = ({
  label,
  path,
  readOnly,
  required,
  showManualError,
  variant,
  validator,
  properties,
}) => {
  const {
    formState: { errors },
    watch,
  } = useFormContext();

  const formValues = watch();

  const errorType = _.get(errors, `${path}.type`) as unknown as string;
  let errorMessage = errorType ? FORM_ERROR_MAPPING[errorType] : undefined;

  if (showManualError && validator?.validate && !validator?.validate(formValues)) {
    errorMessage = validator?.validationMessage ?? FORM_ERROR_MAPPING.invalid;
  }

  const hasError = !!errorMessage;

  return (
    <Grid container>
      <Grid item xs={12}>
        {label && (
          <Typography variant="body1" hasError={hasError}>
            {`${label} ${required ? '*' : ''}`}
          </Typography>
        )}
      </Grid>

      <Grid container spacing={3}>
        {properties.map((property) => (
          <Grid key={property.path} item xs={property.xs} lg={property.lg}>
            <FormField
              key={property.path}
              field={{
                ...property,
                required: required && property.required,
                label: property.label || '',
                path: [path, property.path].join('.'),
                validator: property.validator,
              }}
              showManualError={showManualError}
              required={required && property.required}
              readOnly={readOnly}
              variant={variant}
            />
          </Grid>
        ))}
      </Grid>

      {errorMessage && (
        <Grid item xs={12}>
          <Typography hasError={hasError} variant="body1">
            {errorMessage}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default SingleInstance;
